import { updates, cards, faqs } from '@/mocks/homeData';

const tagBgMap: Record<string, string> = {
  accent: 'bg-accent-100 text-accent-700',
  primary: 'bg-primary-100 text-primary-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

// ---- Updates Section ----

export function UpdatesSection() {
  return (
    <section id="updates" className="py-10 md:py-14 bg-background-100">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-8">
          最新快讯
        </h2>
        <div className="relative max-w-3xl mx-auto">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-300"></div>
          <div className="flex flex-col gap-5">
            {updates.map((item) => (
              <div key={item.id} className="relative pl-10 md:pl-12">
                <div className="absolute left-[9px] md:left-[11px] top-2 w-[9px] h-[9px] rounded-full bg-primary-500 border-2 border-background-100 z-10"></div>
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs text-foreground-500">{item.date}</span>
                  <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${tagBgMap[item.tagColor] || tagBgMap.secondary}`}>
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// ---- Contact Section ----

export function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 bg-background-50">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-8">联系我们</h2>
        <div className="max-w-lg mx-auto bg-background-100 rounded-lg p-6 md:p-8 text-center border border-background-200/70">
          <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-accent-600 text-xl w-6 h-6 flex items-center justify-center"></i>
          </div>
          <h3 className="text-lg font-medium text-foreground-900 mb-3">投稿与咨询</h3>
          <p className="text-sm text-foreground-600 leading-relaxed mb-5">
            欢迎影迷朋友投稿影评、推荐好片或咨询观影问题。我们的编辑团队将在24小时内回复您的来信。
          </p>
          <div className="flex flex-col gap-2 text-sm text-foreground-700">
            <span><i className="ri-mail-line w-5 h-5 inline-flex items-center justify-center mr-2 text-accent-500 align-middle"></i>contact@6080dy.com</span>
            <span><i className="ri-qq-line w-5 h-5 inline-flex items-center justify-center mr-2 text-accent-500 align-middle"></i>QQ：608088888</span>
            <span><i className="ri-wechat-line w-5 h-5 inline-flex items-center justify-center mr-2 text-accent-500 align-middle"></i>微信：movie6080</span>
          </div>
        </div>
      </div>
    </section>
  );
}

// ---- Cards Section ----

export function CardsSection() {
  return (
    <section id="cards" className="py-10 md:py-14 bg-background-100">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">热门推荐</h2>
        <p className="text-sm text-foreground-500 text-center mb-8">精选最新上映热门大片，每一部都值得一看</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <article key={card.id} className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer group">
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`6080电影网 - ${card.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] px-2 py-0.5 bg-accent-500 text-background-50 rounded-full font-medium">{card.tag}</span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="text-xs px-2 py-0.5 bg-background-50/90 text-accent-600 rounded-full font-bold">{card.rating}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-medium text-foreground-900 mb-1">{card.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

// ---- FAQ Section ----

export function FaqSection() {
  return (
    <section id="faq" className="py-10 md:py-14 bg-background-50">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-8">常见问答</h2>
        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqs.map((faq) => (
            <details key={faq.id} className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden" open>
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm md:text-base font-medium text-foreground-900 list-none">
                {faq.q}
                <i className="ri-arrow-up-s-line w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform ml-3 flex-shrink-0"></i>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}